import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Search as SearchIcon, Building2 } from "lucide-react";
import { AdminTabs } from "@/components/AdminTabs";
import { CompanyLogo } from "@/components/TeamBadge";

export default function AdminCompanies() {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const load = async (query = "") => {
    try { const { data } = await api.get("/admin/companies", { params: query ? { q: query } : {} }); setItems(data); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); setItems([]); }
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="container-x py-12" data-testid="admin-companies-page">
      <AdminTabs />
      <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
        <div>
          <h1 className="font-heading text-3xl text-[#1E3F33] font-semibold flex items-center gap-2"><Building2 className="w-6 h-6 text-[#2D6A4F]"/> Companies</h1>
          <p className="text-sm text-[#5C6B64] mt-1">Company accounts that manage multiple collectors. Billing is $10.99 per listed collector.</p>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); load(q); }} className="flex gap-2">
          <input data-testid="admin-companies-search" className="input-soft w-64" placeholder="Search company, email…" value={q} onChange={(e) => setQ(e.target.value)} />
          <button className="btn-secondary px-3" data-testid="admin-companies-search-btn"><SearchIcon className="w-4 h-4"/></button>
        </form>
      </div>
      {items === null ? <p className="text-[#5C6B64]">Loading…</p> : items.length === 0 ? (
        <p className="text-sm text-[#8A9A86]" data-testid="admin-companies-empty">No companies yet.</p>
      ) : (
        <div className="card-soft p-0 overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-companies-table">
            <thead className="bg-[#F0EFEA] text-left text-[#1E3F33]"><tr>
              <th className="px-4 py-2.5 font-medium">Company</th>
              <th className="px-4 py-2.5 font-medium">Collectors</th>
              <th className="px-4 py-2.5 font-medium">Monthly</th>
              <th className="px-4 py-2.5 font-medium">Status</th>
              <th className="px-4 py-2.5 font-medium"></th>
            </tr></thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-t border-[#1E3F33]/8" data-testid={`admin-company-row-${c.id}`}>
                  <td className="px-4 py-2.5"><div className="flex items-center gap-3"><CompanyLogo logo={c.logo_url} name={c.company_name} size="w-9 h-9" testid={`admin-company-logo-${c.id}`} /><div><div className="font-medium text-[#1E3F33]">{c.company_name}</div><div className="text-xs text-[#8A9A86]">{c.email || c.phone || "—"}</div></div></div></td>
                  <td className="px-4 py-2.5 text-[#5C6B64]">{c.seats}</td>
                  <td className="px-4 py-2.5 text-[#5C6B64]">${c.monthly_total.toFixed(2)}</td>
                  <td className="px-4 py-2.5"><span className={`text-[10px] px-2 py-0.5 rounded-full ${c.subscription_active ? "bg-[#2D6A4F]/15 text-[#2D6A4F]" : "bg-[#1E3F33]/10 text-[#5C6B64]"}`}>{c.subscription_active ? (c.subscription_cancelled ? "Active · cancelling" : "Active") : "Inactive"}</span></td>
                  <td className="px-4 py-2.5 text-right"><button data-testid={`admin-company-manage-${c.id}`} onClick={() => navigate(`/admin/companies/${c.id}`)} className="btn-secondary text-xs py-1.5 px-3">Manage</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
